import useMobileRoutes from "../SPA/hooks/useMobileRoutes";
import { getClientType } from "../../lib/common";
import useDesktopRoutes from "../Desktop/hooks/useDesktopRoutes";
import { Link, useHistory as useReactRouterHistory } from "react-router-dom";
import { generatePath } from "react-router";
import { useLocation as useReactRouterUseLocation } from 'react-router';
import useDesktopUseLocation from '../Desktop/hooks/useLocation';
const useRoutes = () => {
    const mobileRoutes = useMobileRoutes();
    const desktopRoutes = useDesktopRoutes();
    if (getClientType() == "mobilev2") {
        return mobileRoutes;
    }
    else {
        return desktopRoutes;
    }
};
function isRoutePath(path) {
    return path.variables !== undefined;
}
export const useLocation = () => {
    if (getClientType() == "mobilev2") {
        return useReactRouterUseLocation();
    }
    return useDesktopUseLocation();
};
export const getLinkComponentAttributes = (path, routes, keepExistingParms = false) => {
    let variables = {};
    console.log('Path', path, routes);
    if (isRoutePath(path)) {
        if (path.variables) {
            variables = path.variables;
        }
        path = path.path;
    }
    console.log('Out path', path, variables);
    if (getClientType() == 'mobilev2') {
        console.log('Variables', variables);
        return {
            component: Link,
            to: generatePath(routes[path].path, variables)
        };
    }
    else {
        let newPath = generatePath(routes[path].path, variables);
        if (keepExistingParms) {
            let urlObj = new URL(document.location.protocol + document.location.hostname + newPath);
            const newSearchParams = urlObj.searchParams;
            let currentUrlParams = new URLSearchParams(document.location.search);
            for (const urlParam of currentUrlParams) {
                if (newSearchParams.has(urlParam[0])) {
                    continue;
                }
                console.log('Variable is', urlParam[0]);
                newSearchParams.set(urlParam[0], urlParam[1]);
            }
            newPath = urlObj.toString();
            console.log('New path is', newPath);
        }
        return {
            component: 'a',
            href: newPath
        };
    }
};
export const useHistory = () => {
    const reactRouterHistory = useReactRouterHistory();
    if (getClientType() == "mobilev2") {
        return reactRouterHistory;
    }
    return {
        push: (target) => {
            document.location.href = target;
        },
        replace: (target) => {
            history.replaceState(null, '', target);
        }
    };
};
export default useRoutes;
